<template>
    <div role="link" class="card-community">
        <img class="w-100"
             style="max-height: 161px; object-fit: cover"
             :src="card.image
             ? card.image
             : 'https://media.istockphoto.com/id/1166892600/photo/diverse-group-of-happy-children-getting-on-school-bus.jpg?s=612x612&w=0&k=20&c=_xwDqXmNiTUg5ZIT98e1dsG2RU6Mrn2hbR8gXoE4GXo='"
        />
        <span class="card-community__card-badge">Card {{ card.sort_by }}</span>
        <span class="card-community__description">{{ card.description  }}</span>
    </div>
</template>

<script>

export default {
    name: 'Card',
    props: ['card', 'index'],
    data() {
        return {
            user: {},
        };
    },
};

</script>
